import { render, staticRenderFns } from "./OfficeChartReceived.vue?vue&type=template&id=96b1b4a0&"
import script from "./OfficeChartReceived.vue?vue&type=script&lang=js&"
export * from "./OfficeChartReceived.vue?vue&type=script&lang=js&"
import style0 from "./OfficeChartReceived.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports